import { render, staticRenderFns } from "./ChatDrawer.vue?vue&type=template&id=53cca9f6&scoped=true"
import script from "./ChatDrawer.vue?vue&type=script&lang=js"
export * from "./ChatDrawer.vue?vue&type=script&lang=js"
import style0 from "./ChatDrawer.vue?vue&type=style&index=0&id=53cca9f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cca9f6",
  null
  
)

export default component.exports